export const mentionSuggestMarkName = 'mentionSuggest';
export const mentionTrigger = '@';
export const mentionPluginKeyName = 'mentionSuggest';
export const mentionNodeName = 'mention';
